<template>
    <div class="flex-1">
        <ListCorrespondences :nodeId="nodeId"  :forUserOnly="forUserOnly" :forStructureOnly="forStructureOnly" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'InboxStructureView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 2,
                forUserOnly: false,
                forStructureOnly: true
            }
        },
	}
</script>